module.exports = __webpack_public_path__ + "media/images/jad-sf-side-a86621a129db76d5fd6f5c3609ddadcd.png";